/* tslint:disable */
import {Injectable} from '@angular/core';
import {BaseRestService} from './base-rest.service';
import {HttpClient} from '@angular/common/http';
import {AppSettingsService} from './app-settings.service';
import {Observable} from 'rxjs';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {SharedModule} from '../shared.module';
import {PlayerConfigurationDefinition} from '../models/player-config-list-option';

@Injectable({providedIn: SharedModule})
export class PlayerConfigurationDefinitionService extends BaseRestService {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }

  protected get className(): string {
    return 'PlayerConfigurationDefinitionService';
  }

  protected get isAnonymous(): boolean {
    return false;
  }

  getList(clientUUID: string, subscriptionUUID: string,): Observable<SendBackResult<ArrayResponse<PlayerConfigurationDefinition>>> {
    return this.get<ArrayResponse<PlayerConfigurationDefinition>>(`/Client/${clientUUID}/Subscription/${subscriptionUUID}/PlayerConfiguration/Definitions`);
  }

  getListClient(clientUUID: string): Observable<SendBackResult<ArrayResponse<PlayerConfigurationDefinition>>> {
    return this.get<ArrayResponse<PlayerConfigurationDefinition>>(`/Client/${clientUUID}/PlayerConfiguration/Definitions`);
  }
}
